import axios from 'axios';

import {
	isNarrowScoped,
} from 'Vulture/Permissions';

import {
	broncoURL,
} from './ENV';

import {
	getSession,
} from './Session';


export const sendForgotPasswordEmail = async (email) => {
	const url = `${broncoURL}/password/forgot`;

	const body = {
		email,
	};

	try {
		const res = await axios.post(url, body, {
			headers: {
				'content_type': 'application/json',
			},
		});

		return {
			res,
			data: res.data,
		};
	} catch (err) {
		if (axios.isAxiosError(err)) {
			return {
				err:  true,
				res:  err?.response || {},
				data: err?.response?.data || {},
			};
		}

		return {
			err:  true,
			res:  {},
			data: {},
		};
	}
};

export const registerUser = async (body) => {
	const url = `${broncoURL}/register_user`;

	try {
		const res = await axios.post(url, body, {
			headers: {
				'content_type':   'application/json',
				'X-Auth-Session': getSession().session,
			},
		});

		return {
			res,
			data: res.data,
		};
	} catch (err) {
		if (axios.isAxiosError(err)) {
			return {
				err:  true,
				res:  err?.response || {},
				data: err?.response?.data || {},
			};
		}

		return {
			err:  true,
			res:  {},
			data: {},
		};
	}
};

export const getUsersByAccount = (accountUUID) => {
	const url = `${broncoURL}/account/${accountUUID}/users`;

	return fetch(url, {
		body:    '{}',
		headers: {
			'content_type':   'application/json',
			'X-Auth-Session': getSession().session,
		},
		method: 'POST',
	}).then((res) => {
		return res.json();
	});
};

export const getContentManagersByAccount = async (accountUUID) => {
	if (isNarrowScoped()) {
		return [];
	}

	const users = await getUsersByAccount(accountUUID);

	// A caller without user-management permission on this account gets a 403 error
	// object, not an array (e.g. a content manager here who is an admin elsewhere —
	// the isNarrowScoped guard above races the per-account permission refresh during
	// an account switch). No assignable managers, not a crash.
	if (!Array.isArray(users)) {
		return [];
	}

	// Slideshow-scoped users are the ones assignable to slideshows. Filters on scope_type
	// rather than the role name so a custom copy of content_manager is included.
	return users
		.filter((user) => {
			return user.scope_type === 'slideshow';
		});
};